<div id="sensor-fail-data">
  <section *ngIf="visible">
    <div class="p-grid">
      <div class="p-col-12">
        <button label="Close" type="button" class="p-button-raised  p-button-warning" pButton
          (click)="cancel()"></button>
      </div>
      <div class="p-col-12" style="overflow:hidden;" [hidden]="isLoading === false">
        <div class="spinner-container p-grid p-align-center vertical-container">
          <div class="p-col">
            <img src="../../../../assets/spinner.gif">
          </div>
        </div>
      </div>
    </div>
    <div class="chart-Container" [hidden]="isLoading === true">
      <div id="detailContainer" #detailContainer></div>
    </div>
  </section>
</div>
